/**
 * Created by mac on 2018/8/14.
 */
import Modal from '@/components/Modal/';
import loadingImg from '@/assets/images/img_binding_pic.png';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import { Global } from '../../constants/actionTypes';
import styles from './NoAccount.scss';
import {
  setBindPhoneStatus,
  setBindWxStatus,
} from '../../actions/GlobalAction';
import IconFont from '../Icon/IconFont';
import { getState as getGlobalState } from '../../reducers/Global/GlobalReducer';
@connect(
  (state) => {
    const globalState = getGlobalState(state);
    return {
      data: globalState.get('account'),
    };
  },
  dispatch => ({
    setBindPhoneStatus: status => dispatch(setBindPhoneStatus(status)),
  }),
)
export default class NoAccount extends Component {
  render() {
    const { onModalCancelClick, visible, data } = this.props;
    return (
      <Modal
        width={520}
        visible={visible}
        showFooter={false}
        maskClassName={styles['mask']}
        modalClassName={styles['modal']}
        closable
        isMiddle
        title={i18n.get('phoneModal.bindtitle')}
        onCancel={onModalCancelClick}
      >
        <div className={styles['content']}>
          <div className={styles['left']}>
            <img src={loadingImg}/>
            <p className={styles['content']}>{i18n.get('phoneModal.bindtip')}</p>
          </div>
          <div className={styles['right']}>
            <div className={styles['item']}>
              <div className={styles['item-left']} style={{ color: data.mobile_number ? '#2f2f2f' : '' }}>
                <IconFont name="phone" className={`${styles['icon']} ${data.mobile_number ? styles['active'] : ''}`}/>
                {data.mobile_number || i18n.get('phoneModal.nobind')}
              </div>
              { !data.mobile_number &&
              <button
                className={styles['btn']}
                onClick={() => {
                  this.props.setBindPhoneStatus();
                }}
              >{i18n.get('phoneModal.clickbind')}
              </button> }
            </div>
            <div className={styles['item']} style={{ color: data.mobile_number ? '#2f2f2f' : '' }}>
              <div className={styles['item-left']}>
                <IconFont name="wechat" className={`${styles['icon']} ${data.wechat ? styles['active'] : ''}`}/>
                {data.wechat || i18n.get('phoneModal.nobind')}
              </div>
              { !data.wechat &&
              <button
                className={styles['btn']}
                onClick={() => {
                  const url = `${window.location.href}?callback=true`;
                  window.location.href = `/users/auth/wechat?can_transfer=true&redirect_url=${encodeURIComponent(url)}`;
                }}
              > {i18n.get('phoneModal.clickbind')}
              </button> }
            </div>
          </div>
        </div>

      </Modal>);
  }
}



// WEBPACK FOOTER //
// ./src/components/NoAccount/NoAccount.js